<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import moment from "moment/moment";

// Component Imports
import Button from "../../common/Button.vue";
import FormControlPlainText from "../../common/form-control/FormControlPlainText.vue";

// Props Definition
const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String
});

// Store Access via Instance Proxy
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// State
const isDisabled = ref(false);

// Computed Properties
const lastSent = computed(() => {
    return props.currentData[props.field.name] || '';
});

const dateStr = computed(() => {
    return lastSent.value ? moment(lastSent.value).format('DD MMM YYYY, HH:mm') : '';
});

const partyBookingId = computed(() => {
    return props.currentData.id;
});

// Methods
const resendEmail = async () => {
    isDisabled.value = true;

    try {
        const o = await store.dispatch('request/post', {
            url: 'api/odp/send-party-booking-email',
            postData: {
                partyBookingId: partyBookingId.value
            }
        });

        const newDatetime = o.data.partyBooking.resendEmail;

        store.commit(props.formId + '/presetData', {
            name: props.field.name,
            value: newDatetime
        });
    } finally {
        // Ensuring button re-enables if logic requires,
        // though original kept it disabled until component state reset
        isDisabled.value = false;
    }
};
</script>

<template>
    <div>
        <FormControlPlainText class="small">
            Email sent:
            <span v-if="lastSent">{{ dateStr }}</span>
            <em v-else>never</em>
        </FormControlPlainText>

        <Button @click.native="resendEmail" :disabled="isDisabled" class="border">
            Send receipt
        </Button>
    </div>
</template>